module.exports = __webpack_public_path__ + "img/jcb_thumbnail.089453e5.png";